module.exports = __webpack_public_path__ + "bw.svg?5e96c2532be7960e07b4fbb0d854372b";